// ======================================================================
// File Name       : ContentVideoDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { contentVideoEdit, getVideoDetail, getVideoUrl } from '../../actions/content/ContentVideoAction';
import ContentVideoDetail from '../../components/content/ContentVideoDetail';
import ContentVideoPlayer from '../../components/content/ContentVideoPlayer';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import { VIDEO_DEFAULT_SIZE, VIDEO_STATUS } from '../../constants/ContentConstant';
import { CONTENT_VIDEO_EDIT } from '../../constants/FunctionConstants';
import { MODAL_SIZE, MODE } from '../../constants/index';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as Path from '../../constants/PathConstants';
import { canAccessRoute } from '../../utils/AuthedUtils';
import CustomLink from '../../components/button/CustomLink';

class ContentVideoDetailContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      content: null,
      contentInfo: {
        contentList: [],
      },
      showModalPlayer: false,
      videoUrl: {},
      isLoadedVideo: false,
      isVideoAppend: false,
    };
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteOk = this.onDeleteOk.bind(this);
    this.onCloseVideo = this.onCloseVideo.bind(this);
    this.onOpenVideo = this.onOpenVideo.bind(this);
    this.onOpenVideoPlayer = this.onOpenVideoPlayer.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    if (!match || !match.params || match.params.id === null || match.params.id === undefined) {
      this.props.history.goBack();
    } else {
      // #START 6305
      this.props.dispatch(getVideoDetail(match.params.id)).then(() => {
        const { videoInfo } = this.props.content;
        this.setState({
          video: videoInfo.contentList[0],
          isLoadedVideo: videoInfo.contentList[0].videoStatus === VIDEO_STATUS.ONLINE,
        });
      });
      // #END 6305
    }
  }

  /**
   * Open delete confirm dialog
   * @param {*} mdContent
   * @param {*} mdSize
   */
  openDeleteConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  /**
   * Event click button cancel of delete confirm dialog
   */
  onDeleteCancel() {
    this.setState({ showModal: false });
  }

  /**
   * Event click button ok of delete confirm dialog
   */
  onDeleteOk() {
    this.setState({ showModal: false });
    const param = {
      editType: MODE.DELETE_MODE,
      contentSecernId: this.state.video.contentSecernId,
    };
    this.props.dispatch(contentVideoEdit(param, this.props.history));
  }

  onCloseVideo() {
    this.setState({
      showModalPlayer: false,
      videoUrl: {},
      isVideoAppend: false,
    });
  }

  onOpenVideo() {
    const { videoInfo } = this.props.content;
    if (videoInfo && videoInfo.recordNum > 0 && !this.state.isVideoAppend) {
      this.setState({ isVideoAppend: true });
      const playerParams = {
        contentSecernId: videoInfo.contentList[0].contentSecernId,
        videoInfo: {
          videoWidth: VIDEO_DEFAULT_SIZE.WIDTH,
          videoHeight: VIDEO_DEFAULT_SIZE.HEIGHT,
        },
      };
      this.props.dispatch(getVideoUrl(playerParams)).then(() => {
        const { videoUrl } = this.props.content;
        this.setState({
          videoUrl,
          showModalPlayer: true,
        });
      });
    }
  }

  onOpenVideoPlayer() {
    this.setState({
      showModalPlayer: true,
      videoUrl: {},
      isVideoAppend: true,
    });
  }

  goBack() {
    this.props.history.goBack();
  }

  /**
   * Render function of component
   */
  render() {
    const editPath = this.state.video
      ? `/${Path.CONTENT}/${Path.CONTENT_VIDEO}/${this.state.video.contentSecernId}/edit`
      : '';
    const canEditDelete = canAccessRoute(CONTENT_VIDEO_EDIT);
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_VIDEO_LIST}
          text="ビデオ一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="ビデオの詳細" />
        {this.state.video &&
          <ContentVideoDetail
            video={this.state.video}
            onOpenVideo={this.onOpenVideo}
            onCloseVideo={this.onCloseVideo}
            isConfirmDialog={false}
          />}
        <Col sm={12}>
          <Form className='form-horizontal'>
            <Form.Group className="margin-top-20 text-center">
              {this.state.video && canEditDelete &&
              !this.state.video.dataAffiliationType ?
                <Link
                  className="btn btn-primary margin-10 btn-96"
                  role="button"
                  to={editPath}
                >
                  編集
                </Link> : null}
              {this.state.video && canEditDelete &&
              !this.state.video.dataAffiliationType ?
                <Button
                  variant="primary"
                  className="margin-10 btn-96"
                  onClick={this.openDeleteConfirmDialog.bind(this, MessageTemplate.MSG_DEL_VIDEO, null)}
                >
                  削除
                </Button> : null}
            </Form.Group>
          </Form>
        </Col>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onDeleteCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDeleteOk}
        />
        {this.state.videoUrl && <ContentVideoPlayer
          showModal={this.state.showModalPlayer}
          size={MODAL_SIZE.lg}
          videoUrl={this.state.videoUrl}
          onCloseVideo={this.onCloseVideo}
          onOpenVideo={this.onOpenVideo}
          onOpenVideoPlayer={this.onOpenVideoPlayer}
        />}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({ ...{ content: state.content } });

export default connect(mapStateToProps)(ContentVideoDetailContainer);
